import { useMemo } from 'react';
import DOMPurify from 'dompurify';

export const useSanitize = (unsafeHtml) => useMemo(() => DOMPurify.sanitize(unsafeHtml, { ADD_ATTR: ['target'] }), [unsafeHtml]);
